import { connect } from 'react-redux';
import Accessibility from '../components/Accessibility/index';
import { hideModal, setBodyClass } from '../redux/accessibility/actions';

@connect(
  function ({ app: { accessibility }, router }) {
    return {
      showModal: accessibility.get('showModal'),
      router,
    };
  },
  function (dispatch) {
    return {
      hideModal: () => dispatch(hideModal()),
      setBodyClass: (bodyClass) => dispatch(setBodyClass(bodyClass)),
    };
  },
)
export default class AccessibilityContainer extends Accessibility {}
